export default function ({ $device }) {
  // Only load the chat script for desktop devices
  if (!$device.isMobile && process.client) {
    // Add a 10-second delay before loading the chat script
    setTimeout(() => {
      try {
        (function(d, s, id, t) {
          if (d.getElementById(id)) return;
          var js = d.createElement(s);
          js.id = id;
          js.async = true;
          js.type = 'text/javascript';
          js.src = 'https://widget.oncustomer.canifa.com/js/index.js?token=' + t;
          var s = d.getElementsByTagName('script')[0];
          s.parentNode.insertBefore(js, s);
        })(document, 'script', 'oc-chat-widget-bootstrap', '52f265e769d692dac5c53a886be37eb0');
      } catch (error) {
        console.error('Failed to load OnCustomer chat widget:', error);
      }
    }, 10000); // 10 seconds delay
  }
}
